import React from 'react';
import { countdownLabel } from '../../derivations/schedule';

export const NextSessionPip = ({ schedule, palette, c, bodyFont }) => {
  const countdown = countdownLabel(schedule);
  if (!countdown) return null;
  const isTonight = countdown === 'Tonight';
  if (!isTonight && countdown !== 'Tomorrow') return null;
  return (
    <span style={{
      fontFamily: bodyFont,
      fontSize: '0.7rem',
      fontWeight: 600,
      letterSpacing: '0.04em',
      color: isTonight ? c.textOnAccent : palette.light,
      padding: '2px 8px',
      borderRadius: 999,
      background: isTonight ? palette.color : 'transparent',
      border: isTonight ? `1px solid ${palette.color}` : `1px solid ${palette.color}55`,
    }}>{countdown}</span>
  );
};
